import { render, staticRenderFns } from "./CommunicationsTab.vue?vue&type=template&id=34b8cbc2&scoped=true"
import script from "./CommunicationsTab.vue?vue&type=script&lang=ts"
export * from "./CommunicationsTab.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationsTab.vue?vue&type=style&index=0&id=34b8cbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b8cbc2",
  null
  
)

export default component.exports